import { RouteProps } from 'react-router-dom';
import * as routes from '../../../../../common/constants/routes';
import { Templates } from './Templates/Templates';
import { AdAccount } from './AdAccount/AdAccount';
import { Chatbot } from './Chatbot/Chatbot';
import { CustomerChatWidget } from './CustomerChatWidget/CustomerChatWidget';
import { SystemMessages } from './SystemMessages/SystemMessages';
import { Users } from './Users/Users';
import { Maintenance } from './Maintenance/Maintenance';
import { SMSActivationPage } from './SMS/SMSActivationPage/ActivationPage';
import { InboxSettingsSection } from '../../../configure/panels/sections/InboxSettingsSection/InboxSettingsSection';
import { MobileMonkeyApi } from '../../../automation/MobileMonkeyApi/MobileMonkeyApi';

export type SettingsSectionDefinition = {
  id: string;
  path: (chatbotId: number) => string;
  name: string;
  component: RouteProps['component'];
};

export const SMS_SECTION_ID = 'sms';
export const USERS_SECTION_ID = 'users';

export const SETTINGS_SECTIONS: SettingsSectionDefinition[] = [
  {
    id: 'chatbot',
    name: 'Chatbot',
    path: routes.SETTINGS_CHATBOT,
    component: Chatbot,
  },
  {
    id: 'inbox',
    name: 'Inbox',
    path: routes.SETTINGS_INBOX,
    component: InboxSettingsSection,
  },
  {
    id: 'customer-chat-widget',
    name: 'Customer Chat Widget',
    path: routes.SETTINGS_CUSTOMER_CHAT_WIDGET,
    component: CustomerChatWidget,
  },
  {
    id: 'api',
    name: 'Customers.ai API',
    path: routes.SETTINGS_MM_API,
    component: MobileMonkeyApi,
  },
  {
    id: 'system-messages',
    name: 'System Messages',
    path: routes.SETTINGS_SYSTEM_MESSAGES,
    component: SystemMessages,
  },
  {
    id: 'advertising',
    name: 'Advertising',
    path: routes.SETTINGS_ADVERTISING,
    component: AdAccount,
  },
  {
    id: 'users',
    name: 'Users',
    path: routes.SETTINGS_USERS,
    component: Users,
  },
  {
    id: 'maintenance',
    name: 'Maintenance',
    path: routes.SETTINGS_MAINTENANCE,
    component: Maintenance,
  },
  {
    id: SMS_SECTION_ID,
    name: 'SMS',
    path: routes.SETTINGS_SMS,
    component: SMSActivationPage,
  },
  {
    id: 'templates',
    name: 'Templates',
    path: routes.SETTINGS_TEMPLATES,
    component: Templates,
  },
];
